var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 50,
    viewBox: "0 0 360 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 50,
    fill: "url(#paint0_linear_74_602)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 0H360V50H273.265L260.5 28L245.5 0Z",
    fill: "url(#paint1_linear_74_602)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_602",
    x1: 176.319,
    y1: 0.981093,
    x2: 177.01,
    y2: 36.4695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17398B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_74_602",
    x1: 292.456,
    y1: 45.2249,
    x2: 329.394,
    y2: -15.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E18B19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6BC18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerBg);
export default __webpack_public_path__ + "static/media/hamburger_bg.76c18c3f10a4b2d3dfe570f71484c259.svg";
export { ForwardRef as ReactComponent };